import type { SupportedRepubName } from './types';

export type MatchupCentreConfig = {
  defaultEventDisplayName: string;
  matchCenterLabel: string;
  matchCenterPath: string;
};

/**
 * Matchup Centre configurations for each republic
 */
export const MATCHUP_CENTRE_CONFIGS = {
  GZ: {
    defaultEventDisplayName: 'Serie A',
    matchCenterLabel: 'Match Center',
    matchCenterPath: 'match-centre',
  },
  OC: {
    defaultEventDisplayName: 'EPL',
    matchCenterLabel: 'Match Centre',
    matchCenterPath: 'match-centre',
  },
  US: {
    defaultEventDisplayName: 'NFL',
    matchCenterLabel: 'Match Center',
    matchCenterPath: 'match-center',
  },
  WS: {
    defaultEventDisplayName: 'All',
    matchCenterLabel: 'Match Centre',
    matchCenterPath: 'match-centre',
  },
} satisfies Record<SupportedRepubName, MatchupCentreConfig>;
